import { styled } from '@mui/material'
import { MonetaryValueDataObjectType, Typography } from 'ComponentLibrary'
import TotalRow from 'ComponentLibrary/src/molecules/CalculationTable/TotalRow'
import { CellText } from 'ComponentLibrary/src/molecules/CalculationTable/CellText'
import { ReactNode } from 'react'

export type Row = {
    label: string
    value: ReactNode
    sectionEnd?: boolean
    hasTotal?: boolean
}

export type CalculationTableProps = {
    title: string
    total?: { label: string; value: MonetaryValueDataObjectType }
    rounded?: { label: string; value: MonetaryValueDataObjectType }
    postScriptRow?: { label: string; value: MonetaryValueDataObjectType }
    rows: Row[]
}

/**
 * @deprecated: Please use <Table/> instead
 **/
export default function CalculationTable({ title, total, rows, postScriptRow }: CalculationTableProps) {
    return (
        <Table>
            <thead>
                <tr>
                    <TableHeading colSpan={2} scope="col">
                        <Typography variant="headline5">{title}</Typography>
                    </TableHeading>
                </tr>
            </thead>
            <tbody>
                {rows.map(({ label, value, sectionEnd, hasTotal }, index) => {
                    const borderSize = hasTotal ? '1.5px' : sectionEnd ? '1px' : 'none'
                    return (
                        <TableRow key={label} index={index} borderSize={borderSize}>
                            <TableCell align="left" style={{ paddingLeft: 10 }}>
                                <CellText>{label}</CellText>
                            </TableCell>
                            <TableCell align="right" style={{ paddingRight: 10 }}>
                                <CellText>{value}</CellText>
                            </TableCell>
                        </TableRow>
                    )
                })}
                {total && <TotalRow total={total} />}
                {postScriptRow && <TotalRow total={postScriptRow} fontWeight={200} variant="bodyTextSmall" />}
            </tbody>
        </Table>
    )
}

const Table = styled('table')`
    width: 100%;
    border-collapse: collapse;
`

const TableRow = styled('tr')<{ index: number; borderSize?: string }>(({ theme, index, borderSize }) => ({
    height: '30px',
    backgroundColor: index % 2 === 0 ? theme.palette.green.green10 : theme.palette.white,
    borderBottom: borderSize ? `${borderSize} solid ${theme.palette.green.green50};` : 'none',
}))

const TableHeading = styled('th')(({ theme }) => ({
    textAlign: 'left',
    paddingBottom: theme.spacing(4),
}))

const TableCell = styled('td')<{ align: 'left' | 'right' }>(({ theme, align }) => ({
    ...theme.typography.bodyTextSmall,
    color: theme.palette.customtext.black54,
    textAlign: align,
}))
